import * as React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import * as moment from 'moment';
import { ButtonGroup, IconButton } from '../';
import {
  disapproveBooking,
  dispatchBooking,
  unassignBooking,
} from '../../redux/actions/bookings';

interface Props {
  booking: any;
  handleUpdate?: Function;
  dispatch: Function;
}

/**
 * A group of action buttons for BookingItems
 */
const BookingItemControls = ({
  booking,
  handleUpdate = () => {},
  dispatch,
}: Props) => {
  const isDue = moment().isSameOrAfter(moment(booking.end).startOf('day'));
  const isReadyToStart = moment().isSameOrAfter(
    moment(booking.start).startOf('day'),
  );
  const EditButton = (
    <IconButton
      key="edit"
      icon="pencil"
      className="is-default"
      link={`/bookings/${booking.id}`}
    >
      Edit
    </IconButton>
  );
  const ViewButton = (
    <IconButton
      key="view"
      icon="eye"
      className="is-default"
      link={`/bookings/${booking.id}`}
    >
      View
    </IconButton>
  );
  const CollectButton = (
    <IconButton
      key="collect"
      icon="check-circle"
      className="is-success"
      handleClick={() => {
        if (
          !isReadyToStart &&
          !window.confirm(
            'Are you sure you want to collect this booking early?',
          )
        ) {
          return;
        }
        dispatch(push(`/bookings/${booking.id}/collect`));
      }}
    >
      Collect
    </IconButton>
  );
  const AssignButton = (
    <IconButton
      key="assign"
      icon="check-circle"
      className="is-success"
      link={`/bookings/${booking.id}/assign`}
    >
      Assign Vehicle
    </IconButton>
  );
  const DispatchButton = (
    <IconButton
      key="dispatch"
      icon="check-circle"
      className="is-success"
      handleClick={async () => {
        if (window.confirm('Dispatch this hire?')) {
          await dispatch(dispatchBooking(booking.id));
          handleUpdate();
        }
      }}
    >
      Dispatch
    </IconButton>
  );
  const UnassignButton = (
    <IconButton
      key="unassign"
      icon="times"
      className="is-danger"
      handleClick={async () => {
        if (window.confirm('Really remove this vehicle from this hire?')) {
          await dispatch(unassignBooking(booking.id));
          handleUpdate();
        }
      }}
    >
      Unassign Vehicle
    </IconButton>
  );
  const DisapproveButton = (
    <IconButton
      key="unassign"
      icon="times"
      className="is-danger"
      handleClick={async () => {
        if (window.confirm('Really set this booking as pending?')) {
          await dispatch(disapproveBooking(booking.id));
          handleUpdate();
        }
      }}
    >
      Set as Pending
    </IconButton>
  );
  const ReturnButton = (
    <IconButton
      key="return"
      icon="check-circle"
      className="is-success"
      link={`/bookings/${booking.id}/return`}
    >
      Return Vehicle
    </IconButton>
  );
  const ResolveButton = (
    <IconButton
      key="resolve"
      icon="check-circle"
      className="is-success"
      link={`/bookings/${booking.id}?section=6`}
    >
      Resolve
    </IconButton>
  );
  const CancelButton = (
    <IconButton
      key="cancel"
      icon="times"
      className="is-danger"
      link={`/bookings/${booking.id}/cancel`}
    >
      Didn't Attend
    </IconButton>
  );

  let controls = [];
  switch (booking.status) {
    case 'PENDING':
      controls = [EditButton, CollectButton, CancelButton];
      break;
    case 'UNASSIGNED':
      controls = [AssignButton, DisapproveButton];
      break;
    case 'READY':
      controls = [ViewButton, DispatchButton, UnassignButton];
      break;
    case 'ACTIVE': {
      controls = [ViewButton];
      // If the booking is ready to be returned add a return button
      if (isReadyToStart && isDue) {
        controls.push(ReturnButton);
      }
      break;
    }
    case 'ON-HOLD':
      controls = [ResolveButton];
      break;
    default:
      controls = [ViewButton];
  }

  return <ButtonGroup>{controls}</ButtonGroup>;
};

export default connect()(BookingItemControls);
